import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/free-solid-svg-icons';

const be2024 = "https://docsend.com/view/axjb8hsmw35p9btj"
const be2024_quadchart = "https://docsend.com/view/ux4fygztn7vhghuy"
const tide2024 = "https://docsend.com/view/8ui9pgkh6sxuxape"

export const BE_2024_Brochure = ({isMobile}) => {
  return (
    <div style={{ border: "5px solid white", borderRadius: '8px', backgroundColor: 'white' }}>
      <h2 className="text-center" style={{ color: "black", marginBottom: '8px' }}>
        <a href={tide2024} target="_blank" style={{ color: 'black' }}><b>MagLev Aero Brochure</b>&nbsp;<FontAwesomeIcon icon={faExternalLink} style={{ fontSize: '0.6em' }}/></a>
      </h2>
      <p className="text-center" style={{ color: "black", fontSize: '1.25em', marginBottom: '10px', paddingLeft:isMobile ? '0em':'3.5em', paddingRight:isMobile ? '0em':'3.5em'}}>
        <b>Read more about the advantages and capabilities of the MagLev HyperDrive™ <a href={tide2024} target="_blank"><u style={{color:'blue'}}><b>here</b></u></a>.</b>
      </p>
    </div>
  );
};

export const TIDE_2024_Brochure = ({isMobile}) => {
  return (
    <>
      {/* Brochure */}
      <div style={{ border: "5px solid white", borderRadius: '8px', backgroundColor: 'white' }}>
        <h2 className="text-center" style={{ color: "black", marginBottom: '8px' }}>
          <a href={be2024} target="_blank" style={{ color: 'black' }}><b>MagLev Aero Brochure</b>&nbsp;<FontAwesomeIcon icon={faExternalLink} style={{ fontSize: '0.6em' }}/></a>
        </h2>
        <p className="text-center" style={{ color: "black", fontSize: '1.25em', marginBottom: '10px', paddingLeft:isMobile ? '0em':'3.5em', paddingRight:isMobile ? '0em':'3.5em'}}>
          <b>Read more about the advantages and capabilities of the MagLev HyperDrive™ <a href={be2024} target="_blank"><u style={{color:'blue'}}><b>here</b></u></a>.</b>
        </p>
      </div>
      <br/>
      {/* QuadChart */}
      <div style={{ border: "5px solid white", borderRadius: '8px', backgroundColor: 'white' }}>
        <h2 className="text-center" style={{ color: "black", marginBottom: '8px' }}>
          <a href={be2024_quadchart} target="_blank" style={{ color: 'black' }}><b>QuadChart</b>&nbsp;<FontAwesomeIcon icon={faExternalLink} style={{ fontSize: '0.6em' }}/></a>
        </h2>
        <p className="text-center" style={{ color: "black", fontSize: '1.25em', marginBottom: '10px', paddingLeft:isMobile ? '0em':'3.5em', paddingRight:isMobile ? '0em':'3.5em'}}>
          <b>Access the MagLev Aero QuadChart for TIDE 2024 <a href={be2024_quadchart} target="_blank"><u style={{color:'blue'}}><b>here</b></u></a>.</b>
        </p>
      </div>
    </>
  );
};

